export const Avatar = `
    <Avatar name="Avatar Name" src="https://picsum.photos/200"/>
    <Avatar name="Avatar Name" size="md" src="https://picsum.photos/200"/>
    // Broken image or empty src 
    <Avatar name="Avatar Name" size="lg" src="https://bit.ly/broken-link"/>
`
